import * as React from 'react';
import DownloadBookDropDown from '../common/dropdown/DownloadBookDropDown';

/** Electron */
let electronVersion = () => {
  return <DownloadBookDropDown />;
};

/** Web */
let webVersion = () => {
  return null;
};

/**
 * MAIN
 */
let versions = {
  electron: electronVersion,
  web: webVersion
};

export let DownloadBookManager;
export let configure = mode => {
  DownloadBookManager = versions[mode];
};
